module.exports = __webpack_public_path__ + "static/img/3.88b4229.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/3.png
// module id = 2Ws1
// module chunks = 0